import React, { memo, useContext } from 'react';
import { AppContext } from '@prisjakt/ui-app-context';

type Styling =
  | 'primary'
  | 'light'
  | 'beta'
  | 'v2-light'
  | 'v2-dark'
  | undefined;

const suffix = (styling: Styling) => {
  switch (styling) {
    case 'light':
      return '_white';
    case 'beta':
      return '_beta';
    case 'v2-light':
      return '_v2_light';
    case 'v2-dark':
      return '_v2_dark';
    default:
      return '';
  }
};

type LogoProps = {
  styling?: Styling;
  companyName: string;
  market: string;
  className?: string;
};

const Logo = ({ companyName, market, styling, className }: LogoProps) => {
  const context = useContext(AppContext);

  if (!market) {
    return null;
  }

  const cdn =
    context.market && context.market.cdn
      ? context.market.cdn
      : 'https://cdn.pji.nu';

  return (
    <img
      alt={companyName}
      src={`${cdn}/g/rfe/logos/logo_${market}${suffix(styling)}.svg`}
      className={className}
    />
  );
};

export default memo(Logo);
